import React, { useContext } from 'react';
import { MenuOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Divider, Form, Modal, Row, Table, Typography } from 'antd';

import locale from 'antd/es/locale/pt_BR';
import LayoutDashboard from './../../layout/LayoutAdmin';
import { Loading } from '../../components/Loading';
import { useRespostasSimulador } from './useRespostasSimulador';
import ResponseModal from './components/ResponseModal';
import { colModalChecks } from './GridStyle';
import { GlobalContext } from '../../contexts/globalContext';
import ExcelExportButton from './components/ExcelExportButton';
import './style.css'

const { Title, Text } = Typography;

export const TEXTO_LINHA_DE_CREDITO_NAO_ENCONTRADA = "Não foi possível identificar uma linha de crédito";

const RespostasSimulador: React.FC = () => {

    const {
        isLoading,
        refContagemDoFiltro,
        isResponseModalVisible,
        responseModalData,
        formattedColumns,
        visibleColumns,
        responses,
        isColumnsConfigModalVisible,
        handleOpenColumnsConfigModal,
        handleCloseColumnsConfigModal,
        formRef,
        handleSubmitColumnsConfig,
        handleCloseResponseModal,
        allAvailableColumnsTitles,
    } = useRespostasSimulador();

    const { theme } = useContext(GlobalContext);

    return (
        <LayoutDashboard>
            <Loading
                loading={isLoading}
            >
                <Row>
                    <Col span={24}>
                        <Row
                            justify='space-between'
                        >
                            <Title level={4}>
                                <MenuOutlined style={{ fontSize: 22, marginRight: 10 }} />
                                {"Simulador Inteligente"}
                            </Title>

                            <Button
                                href='/simulador-inteligente'
                                target='_blank'
                                type="primary"
                                className="botaoVerdeBaixarTodas"
                            >
                                ACESSAR SIMULADOR
                            </Button>
                        </Row>

                        <Divider />
                    </Col>

                    <ExcelExportButton
                        data={responses}
                    />

                    <Button
                        type="primary"
                        onClick={handleOpenColumnsConfigModal}
                        style={{
                            marginBottom: 16,
                            marginLeft: 4
                        }}
                    >
                        Colunas
                    </Button>
                </Row>

                <Table
                    className='marginTopTables tabela-respostas-simulador'
                    rowKey={(record) => record._id}
                    columns={visibleColumns}
                    dataSource={responses}
                    scroll={{ x: 1000 }}
                    rowClassName={(record) => (!!record.respostas.find((e) => e.result === TEXTO_LINHA_DE_CREDITO_NAO_ENCONTRADA) ? "red" : "")}
                    onChange={
                        (pagination, filters, sorter, extra) => {
                            refContagemDoFiltro.current = extra.currentDataSource
                        }
                    }
                    size="small"
                    // pagination={{
                    //     locale: { items_per_page: '' },
                    //     showSizeChanger: false,
                    //     defaultPageSize: 100,
                    //     position: [],
                    //     pageSizeOptions: ['10', '20', '50', '100']
                    // }}
                    pagination={false}
                    title={(registros) => {

                        return (
                            <div
                                style={{
                                    backgroundColor: theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                    padding: 10,
                                    margin: -8,
                                    marginBottom: 0.5
                                }}
                            >
                                <Text>
                                    {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                        responses.length :
                                        refContagemDoFiltro.current.length} num total de ${responses.length} `}
                                </Text>
                            </div>
                        )
                    }}
                    locale={locale.Table}
                />
            </Loading>

            <ResponseModal
                visible={isResponseModalVisible}
                response={responseModalData}
                onClose={handleCloseResponseModal}
            />

            <Modal
                title="Selecione as colunas da tabela"
                visible={isColumnsConfigModalVisible}
                onCancel={handleCloseColumnsConfigModal}
                style={{
                    top: 20
                }}
                className="modalMunicipiosFiltros_fiudefvbiawe"
                footer={[
                    <Button
                        key="back"
                        onClick={handleCloseColumnsConfigModal}
                    >
                        Cancelar
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        onClick={handleSubmitColumnsConfig}
                    >
                        Salvar
                    </Button>
                ]}
                key="modalListagemMunicipios"
            >
                <Form
                    name="formColunasTable"
                    ref={formRef}
                    style={{
                        width: '100%'
                    }}
                    onFinish={handleSubmitColumnsConfig}
                >
                    <Row>
                        {
                            allAvailableColumnsTitles.map((column) => {
                                return (
                                    <Col
                                        key={column}
                                        {...colModalChecks}
                                    >
                                        <Form.Item
                                            name={column}
                                            style={{
                                                margin: 5
                                            }}
                                            valuePropName={'checked'}
                                            initialValue={!!visibleColumns.find((e) => e.title === column)}
                                        >
                                            <Checkbox
                                            >{column}</Checkbox>
                                        </Form.Item>
                                    </Col>
                                )
                            })
                        }
                    </Row>
                </Form>
            </Modal>
        </LayoutDashboard >
    );
}

export default RespostasSimulador;
